module.exports = __webpack_public_path__ + "img/8.612bf6f9.png";